import React from "react";
import "./ImageBox.scss";
export default function ImageBox({ title, imageUrl, imageMobile }) {
    return (React.createElement("div", { className: "line-detail" },
        React.createElement("picture", null,
            React.createElement("source", { src: "#", media: "(max-width:768px)", srcSet: imageMobile }),
            React.createElement("img", { src: imageUrl, alt: "" })),
        React.createElement("h3", { className: "line-title" }, title)));
}
